import { Box, Skeleton } from '@mui/material'
import Grid from '@mui/material/Unstable_Grid2'
import useScreenWidth from '../../hooks/useScreenWidth'
import CardsSkeleton from './CardsSkeleton'

function HomeResourcesFeedSkeleton() {
  const isMobile = useScreenWidth(960)

  return (
    <Grid
      container
      spacing={isMobile ? 5 : 4}
      sx={theme => ({
        width: '100%',
        margin: 0,
        [theme.breakpoints.up('sm')]: {
          margin: '-40px auto 0px'
        }
      })}
    >
      <Grid xs={12} sx={{ borderBottom: '1px solid  #C7CCD1', marginTop: 32, marginBottom: 24 }}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Skeleton animation="wave" width={120} height={46} variant="text" />
          <Skeleton animation="wave" width={65} height={30} variant="text" />
        </Box>
      </Grid>
      <Grid container spacing={2}>
        <Grid xs={12} md={6} lg={4}>
          <CardsSkeleton />
        </Grid>
        <Grid xs={12} md={6} lg={4}>
          <CardsSkeleton />
        </Grid>
        <Grid xs={12} md={6} lg={4}>
          <CardsSkeleton />
        </Grid>
      </Grid>
    </Grid>
  )
}

export default HomeResourcesFeedSkeleton
